// Modules
import cn from 'classnames';

// Types
import type { TTableProps } from './Table.type';

// Styles
import styles from './styles.module.scss';

// Constants
import { TABLE_DEFAULT_PROPS } from './Table.constant';

const Table = (props: TTableProps) => {
	const {
		children,
		className,
		borderCell = TABLE_DEFAULT_PROPS.borderCell,
		hoverable,
		striped,
	} = props;

	const tableCN = cn(styles.legion_table, className, styles[borderCell], {
		[styles.hoverable]: hoverable,
		[styles.striped]: striped,
	});

	return (
		<table className={tableCN}>
			{children}
		</table>
	);
}

export default Table;
